export default __webpack_public_path__ + "static/media/flavianunes_curlss.1080df29.jpg";